import { DEFAULT_VIEW_DISABLED_ROUTES } from '../constants';

export const shouldDisableDefaultView = (pathname) =>
  DEFAULT_VIEW_DISABLED_ROUTES.some((route) => pathname?.includes(route));

export const getCustomDDLConfig = (locale) => {
  return {
    country: locale?.split('-')[1],
    language: locale?.split('-')[0],
    locale,
    location: window?.location?.href,
    origin: window?.location?.hostname,
    title: document?.title,
    viewId: window?.location?.pathname,
  };
};
